export const ArrowLeftOutline = ({ className, onClick, stroke='black' }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.47656 12.5664L20.4766 12.5664M4.47656 12.5664L10.4766 6.56641M4.47656 12.5664L10.4766 18.5664"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
